import { useAppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { ICustomProperties, IMetricTelemetry, IExceptionTelemetry, IEventTelemetry } from '@microsoft/applicationinsights-web';

// eslint-disable-next-line import/prefer-default-export
export const useAppInsights = () => {
    const appInsights = useAppInsightsContext();

    return {
        trackEvent: (name: string, properties: Record<string, string | number | boolean | null> = {}) => {
            const telemetry: IEventTelemetry = { name, properties: properties as ICustomProperties };
            appInsights.trackEvent(telemetry, properties as ICustomProperties);
        },
        trackMetric: (name: string, value: number, properties: Record<string, string> = {}) => {
            const telemetry: IMetricTelemetry = { name, average: value, sampleCount: 1, properties: properties as ICustomProperties };
            appInsights.trackMetric(telemetry, properties as ICustomProperties);
        },
        trackException: (error: Error, properties: Record<string, string> = {}) => {
            const telemetry: IExceptionTelemetry = { error, properties: properties as ICustomProperties };
            appInsights.trackException(telemetry, properties as ICustomProperties);
        }
    };
};